import './Statement.css';

export function Statement () {
    return <div className='statement'>
        <ul>
            <li>报告使用说明：</li>
            <li>1.本报告内容仅通过邮箱收到的账单原件进行分析而成，依据使用单位的委托由我司代理完成。我司仅负责数据分析，不对报告内容准确性、完整性等问题承担任何责任。</li>
            <li>2.本报告仅供使用者参考，我司不承担据此报告产生的任何法律责任。</li>
        </ul>
    </div>
}